import { render, staticRenderFns } from "./activityNotifications.html?vue&type=template&id=3c82d6c6&external"
import script from "./activityNotifications.vue?vue&type=script&lang=js"
export * from "./activityNotifications.vue?vue&type=script&lang=js"
import style0 from "./activityNotifications.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports